import React from 'react';

const findColor = (color, colorList) =>
	colorList.find(x => color && color.toLowerCase().includes(x));

const getColorForSwatch = (normalColor, fullColor) => {
	const colorList = [
		'beige',
		'brun',
		'black',
		'noir',
		'negro',
		'blue',
		'bleu',
		'azul',
		'brown',
		'marron',
		'gold',
		'oro',
		'gray',
		'grey',
		'gris',
		'green',
		'vert',
		'verde',
		'orange',
		'naranja',
		'purple',
		'violet',
		'morado',
		'red',
		'rouge',
		'rojo',
		'silver',
		'argent',
		'plata',
		'white',
		'blanc',
		'yellow',
		'jaune',
		'amarillo'
	];

	const otherList = ['other', 'autre', 'otro'];
	const normalized = normalColor && normalColor.toLowerCase();

	return (
		(!otherList.includes(normalized) && normalized) ||
		findColor(fullColor, colorList)
	);
};

const ColorSwatch = props => {
	const { normalizedColor, fullColor } = props;
	const colorForSwatch = getColorForSwatch(normalizedColor, fullColor);
	// Return null if we can't reliably match a color
	return (
		(colorForSwatch && (
			<span
				className={`normalized-swatch normalized-swatch-${colorForSwatch} mr-3`}
			/>
		)) ||
		null
	);
};

export default ColorSwatch;
